// extracted by mini-css-extract-plugin
module.exports = {"root":"uq9dLE","label":"UWvXrH","dropzone":"kK3kIB","thumbnail":"A+2DD6","delete":"ZNaJlQ","uploading":"sfCKz7"};